/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BlockIcon16Light } from './BlockIcon16Light';
import { BlockIcon16Regular } from './BlockIcon16Regular';
import { BlockIcon16Solid } from './BlockIcon16Solid';
import { BlockIcon20Light } from './BlockIcon20Light';
import { BlockIcon20Regular } from './BlockIcon20Regular';
import { BlockIcon20Solid } from './BlockIcon20Solid';
import { BlockIcon24Regular } from './BlockIcon24Regular';
import { BlockIcon24Solid } from './BlockIcon24Solid';
import { BlockIcon32Regular } from './BlockIcon32Regular';
import { BlockIcon64Regular } from './BlockIcon64Regular';
var sizes = {
    16: {
        light: BlockIcon16Light,
        regular: BlockIcon16Regular,
        solid: BlockIcon16Solid,
    },
    20: {
        light: BlockIcon20Light,
        regular: BlockIcon20Regular,
        solid: BlockIcon20Solid,
    },
    24: {
        regular: BlockIcon24Regular,
        solid: BlockIcon24Solid,
    },
    32: {
        regular: BlockIcon32Regular,
    },
    64: {
        regular: BlockIcon64Regular,
    },
};
export var BlockIcon = forwardRef('BlockIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
